import PropTypes from 'prop-types';
import React from 'react';
import { Row, Col, Label } from 'reactstrap';
import BaseComponent from './BaseComponent';
import { safeJSONParse } from 'helpers/sf_utils';
import car1 from 'assets/images/quote-funnel/answer/car1.svg'
import car2 from 'assets/images/quote-funnel/answer/car2.svg'
import car3 from 'assets/images/quote-funnel/answer/car3.svg'
/**
 * InputComponent is a reusable React component that renders a form component field with an associated label and tooltip.
 * 
 * @param {Object} props - The props for the InputComponent.
 * @param {Object} props.label - An object containing properties related to the label.
 * @param {string} props.label.name - The name of the label.
 * @param {string} props.label.tooltip - The tooltip message for the label.
 * @param {Object} props.component - An object containing properties related to the component field.
 * @param {string} props.component.id - The ID of the component field.
 * @param {string} props.component.name - The name of the component field.
 * @param {string} props.component.type - The type of the component field (default is 'text').
 * @param {Object} props.validation - An object containing form validation properties.
 * @param {Function} props.validation.handleChange - The function to handle component changes.
 * @param {Function} props.validation.handleBlur - The function to handle component blur.
 * @param {Object} props.validation.values - An object containing form values.
 * @param {Object} props.validation.touched - An object indicating whether fields have been touched.
 * @param {Object} props.validation.errors - An object containing validation errors.
 * 
 * @returns {JSX.Element} - A React component that renders an component field with label and tooltip.
 */
const DefaultComponent = ({ index, question, onChangeEvent }) => {
    const handleChange = (e, value) => {
        e.preventDefault();
        onChangeEvent(value)
    }

    const QUESTION_NAME_TYPES = {
        NUM_VEHICLES: "num_vehicles",
        CURRENT_CARRIER: "current_carrier",
        CARRIER: "carrier"
    }
    let question_drop_down_values = safeJSONParse(question?.drop_down_values, []);
    if (question?.field_name === QUESTION_NAME_TYPES.CARRIER) {
        question_drop_down_values.sort((a, b) => a.label.localeCompare(b.label));
    
        const otherIndex = question_drop_down_values.findIndex(option => option.label === "Other");
    
        // If "Other" is found, move it to the end of the array
        if (otherIndex !== -1) {
            const otherOption = question_drop_down_values.splice(otherIndex, 1)[0];
            question_drop_down_values.push(otherOption);
        }
    }
    const getColLength = (question, questionDropDownValues) => {
        const length = questionDropDownValues?.length || 0;
        if ([QUESTION_NAME_TYPES.CURRENT_CARRIER, QUESTION_NAME_TYPES.CARRIER].includes(question?.field_name)) {
            return 6
        }
        else if (length > 30) {
            return 2
        }
        else if (length > 18) {
            return 6
        }
        else if (length > 12) {
            return 6
        }
        else if (length > 2) {
            return 4
        }
        else if (length > 1) {
            return 6
        }
        else {
            return 12
        }
    }

    return (
        <BaseComponent question={question} key={index || 0}>
            <Row>
                {(question_drop_down_values || [])?.map((question_drop_down_value, idx) => {
                    return (
                        <Col
                            key={`question_${question.field_name}_${question_drop_down_value?.label}_${question_drop_down_value?.value}_${idx}`}
                            md={getColLength(question, question_drop_down_values)}
                            className='mb-2'
                        >
                            <div className="quote-funnel-answer-check text-center">
                                <input
                                    type="radio"
                                    className='btn-check'
                                    name={question.field_name}
                                    value={question_drop_down_value.value}
                                    id={`${question.field_name}_${question.value}`}
                                    checked={question_drop_down_value.label == question.value}
                                    autoComplete="off"
                                />
                                <Label id={`quote-funnel-answer-check-${index || 0}-${idx}`} className="btn text-capitalize"
                                    onClick={(e) => handleChange(e, question_drop_down_value?.value)}
                                    htmlFor={`${question.field_name}_${question_drop_down_value.value}`}>
                                    {QUESTION_NAME_TYPES.NUM_VEHICLES === question.field_name ? (
                                        <div className="py-3">
                                            <img className="img-fluid my-3" src={question_drop_down_value?.label.toString() === "1" ? car1 : question_drop_down_value?.label.toString() === "2" ? car2 : car3} />
                                            <h4 className="text-capitalize text-black" >{question_drop_down_value.label}</h4>
                                        </div>
                                    ) : question_drop_down_value.label}
                                </Label>
                            </div>
                        </Col>
                    )
                })}
            </Row>
        </BaseComponent>
    );

}

DefaultComponent.propTypes = {
    label: PropTypes.object,
    component: PropTypes.object,
    validation: PropTypes.object,
};

export default DefaultComponent;
